module.exports = __webpack_public_path__ + "img/bg2.aff5a2c6.png";